// extracted by mini-css-extract-plugin
export default {"bonuses":"cart_bonuses__RRXTh"};